import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import { INews } from 'ApiPackage/NewsModule/interfaces/INews';
import { coreHideNotices } from 'CorePackage/MainModule/actions/coreActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { NewsItem } from './NewsItem';
import { newsGetData } from '../actions/newsActions';
import { getNewsData } from '../selectors/newsSelectors';
import styles from './NewsContainer.module.scss';
import { NewsTypesEnum } from '../enums/NewsTypesEnum';

interface INewsProps {
  className?: string;
  locationMainPage?: boolean;
}

interface INewsStoreProps {
  data?: INews[];
}

const NewsContainerWithoutStore = ({ className, locationMainPage, data }: INewsProps & INewsStoreProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(newsGetData());
    return () => {
      dispatch(coreHideNotices());
    };
  }, [dispatch]);

  return (
    <div className={className}>
      <h2 className={styles.Title}>Новости</h2>
      <div className={locationMainPage ? styles.NewsTiles : styles.NewsBlock}>
        {data && data?.length > 0 && (
          <>
            {data?.map(el => (
              <NewsItem key={el.id} data={el} locationMainPage={locationMainPage} />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  data: getNewsData(state, NewsTypesEnum.NEWS),
});

export const NewsContainer = connect(mapStateToProps)(NewsContainerWithoutStore);
